module.exports = __webpack_public_path__ + "img/phone-2.ae24eb9.webp?v=1747398688961";